import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const BASE = "/api/v1/erp/stock";

export const fetchStockLevels = createAsyncThunk(
  "stock/fetchStockLevels",
  async (params?: string): Promise<any> => {
    const query = params ? `?${params}` : "";
    const response = await axios.get(`${BASE}/levels${query}`);
    return response.data; // array
  }
);

export const fetchStockMovements = createAsyncThunk(
  "stock/fetchStockMovements",
  async (params?: string): Promise<any> => {
    const query = params ? `?${params}` : "";
    const response = await axios.get(`${BASE}/movements${query}`);
    return response.data; // array
  }
);

export const adjustStock = createAsyncThunk("stock/adjust", async (payload: any): Promise<any> => {
  const response = await axios.post(`${BASE}/adjustments`, payload);
  return response.data;
});

// Batches that currently have stock at a location (for the invoice item picker's
// location-dependent Batch filter).
export const fetchLocationBatches = createAsyncThunk(
  "stock/fetchLocationBatches",
  async (locationId: string): Promise<any> => {
    const response = await axios.get(`${BASE}/location-batches?locationId=${locationId}`);
    return response.data; // array
  }
);
